<template>   
<div class="side-bar-wrapper">     
<div class="user-info" @click="handlePerson">       
<div class="avatar-div">         
<el-avatar class="avatar" :size="56" :src="userInfo && userInfo.avatar">           <img src="@/assets/images/avatar.svg">         
</el-avatar>         
<div v-if="userInfo && userInfo.teacher" class="label">教师
</div>       
</div>       
<div class="name">{{ userInfo && userInfo.realName }}
</div>       
<div v-if="userInfo && userInfo.collegeName" class="school">{{ userInfo && userInfo.collegeName }}
</div>     
</div>     
<div class="menu-list scrollbar-hidden">       
<div v-if="menuListForShow.list && menuListForShow.list.length > 0" class="section">         
<div           v-for="item in menuListForShow.list"           class="menu-item"           :class="{active: item.routeName === routeName}"           :key="item.name"           @click="handleClick(item)"         >           <i class="icon iconfont" :class="item.icon"></i>           <span class="name">{{ item.name }}</span>         
</div>       
</div>       
<div         v-for="item in menuListForShow.commonList"         class="menu-item"         :class="{active: item.routeName === routeName}"         :key="item.name"         @click="handleClick(item)"       >         <i class="icon iconfont" :class="item.icon"></i>         <span class="name">{{ item.name }}</span>       
</div>       
<div v-if="menuListForShow.entryList && menuListForShow.entryList.length > 0" class="section-top">         
<div           v-for="item in menuListForShow.entryList"           class="menu-item"           :class="{active: item.routeName === routeName}"           :key="item.name"           @click="handleClick(item)"         >           <i class="icon iconfont" :class="item.icon"></i>           <span class="name">{{ item.name }}</span>         
</div>       
</div>     
</div>   
</div> </template>

<script>
import axios from 'axios';
import { getToken } from '@/utils/auth'

export default {
  name: 'SideBar',
  data() {
    return {
      routeName: '',
      // 游客：'0' TOURIST，院校管理员：'1' COLLEGE_ADMIN，教师：'2' TEACHER，学生：'3' STUDENT
      menuList: [
        {
          name: '教学空间',
          icon: 'icon-teach-space',
          routeName: 'TeachingSpace',
          roles: ['2']
        },
        {
          name: '我的题库',
          icon: 'icon-tiku',
          routeName: 'QuestionBank',
          roles: ['2']
        },
        {
          name: '我加入的班级',
          icon: 'icon-class',
          routeName: 'JoinClass',
          roles: ['3']
        },
        {
          name: '教材发放',
          icon: 'icon-jcff',
          routeName: 'ProvideBook',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '试用申请',
          icon: 'icon-tushuguan',
          routeName: 'SampleBook',
          roles: []
        },
        {
          name: '院校信息',
          icon: 'icon-mulu',
          routeName: 'Academy',
          roles: ['1']
        },
        {
          name: '我的学习报告',
          icon: 'icon-trending-up',
          routeName: 'StudyReport',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '我的收藏',
          icon: 'icon-favorite',
          routeName: 'Collect',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '购买记录',
          icon: 'icon-shopping-cart',
          routeName: 'Record',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '使用帮助',
          icon: 'icon-help-circle',
          routeName: 'Help',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '我的反馈',
          icon: 'icon-feedback',
          routeName: 'Feedback',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '资料与安全',
          icon: 'icon-shield',
          routeName: 'Person',
          roles: ['0', '1', '2', '3']
        },
        {
          name: '营销管理',
          icon: 'icon-xiaoshoubaobiao',
          roles: ['无'] //无实际意义仅为了位置展示，由YxMenu判断权限
        },
      ],
      checkEditorUrl: ''
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    menuListForShow() {
      const roles = this.userInfo && this.userInfo.roleList || []
      const list = []
      this.menuList.forEach(item => {
        if (roles.some(child => item.roles.includes(child))) {
          if (item.name === '教材发放') {
            if (this.userInfo && this.userInfo.hasGrant) {
              list.push(item)
            }
          } else {
            list.push(item)
          }
        } else {
          if (item.name === '试用申请') {
            if (this.userInfo && this.userInfo.canApply) {
              list.push(item)
            }
          }
          if (item.name === '营销管理') {
            if (this.userInfo && this.userInfo.extras?.YxMenu) {
              list.push(item)
            }
          }
        }
      })
      return {
        list: list.filter(item => item.roles[0] !== '无' && item.roles.length < 4),
        commonList: list.filter(item => item.roles.length === 4),
        entryList: list.filter(item => item.roles[0] === '无')
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        console.log(to)
        if(to.name==='my') {
          this.handleDefault();
        } else {
          this.routeName = to.name
        }
      },
      immediate: true
    },

  },
  mounted() {
    this.checkEditorToken();
    this.handleDefault();
  },
  methods: {
    handleDefault() {
      const list = [...this.menuListForShow.list, ...this.menuListForShow.commonList, ...this.menuListForShow.entryList]
      const routeName = list[0].routeName
      if (!list.some(item => item.routeName === this.$route.name)) {
        this.$router.replace({
          name: routeName
        })
      }
    },
    handleClick(item) {
      if (item.name === '营销管理') {
        if (this.checkEditorUrl) {
          window.open(`${this.checkEditorUrl}&ele=${getToken()}`)
        }
      } else {
        this.$router.push({
          name: item.routeName
        })
      }
    },
    handlePerson(){
      this.$router.push({name: 'Person'})
    },
    checkEditorToken() {
      let url = process.env.VUE_APP_BASE_API + '/api/member/checkEditorToken';
      axios.get(url, {
        headers: {
          'Authorization': getToken(),
          'editor-token': ''
        }
      }).then(response => {
        const { url } = response.data?.data
        this.checkEditorUrl = url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.side-bar-wrapper {
  padding: 30px 16px 0 16px;
  width: 192px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding-top: 30px;

    .avatar-div {
      .avatar {
        width: 56px;
        height: 56px;
        background: #eee;
        border-radius: 50%;
        :deep(img) {
          width: 100%;
        }
      }
      .label {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -10px;
        padding: 0 10px;
        height: 18px;
        font-size: 12px;
        color: #fff;
        text-align: center;
        background: #ee9360;
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: -3px;
          left: 0;
          width: 24px;
          height: 24px;
          background: #fff;
          transform: translateX(-20px) rotate(45deg);
        }
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: -3px;
          right: 0;
          width: 24px;
          height: 24px;
          background: #fff;
          transform: translateX(20px) rotate(45deg);
        }
      }
    }
    .name {
      padding: 0 12px;
      text-align: center;
      margin-top: 10px;
      font-size: 16px;
      color: #3e4d71;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
    }
    .school {
      display: flex;
      align-items: center;
      margin-top: 10px;
      padding: 0 8px;
      //height: 19px;
      font-size: 12px;
      color: #20a494;
      background: #e5f9f6;
      border-radius: 19px;
    }
  }
  .menu-list {
    margin-top: 40px;
    font-size: 14px;
    color: #3e4d71;
    max-height: calc(100vh - 281px);
    flex: 1;
    .section {
      margin-bottom: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #e6e6e6;
    }
    .section-top {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #e6e6e6;
    }
    .menu-item {
      margin-bottom: 5px;
      padding: 8px 15px;
      cursor: pointer;
      &:hover {
        background: #eef3ff;
        color: #5584fb;
        border-radius: 4px;
      }
      &.active {
        background: #eef3ff;
        color: #5584fb;
        border-radius: 4px;
      }
      .icon {
        margin-right: 10px;
      }
    }
  }
}
</style>
